import type { ReactNode } from 'react';

interface Props {
  desktopAside?: ReactNode;
  children: ReactNode;
  mobileStickyCta?: ReactNode;
  desktopFlowCta?: ReactNode;
}

export function Layout({
  desktopAside,
  children,
  mobileStickyCta,
  desktopFlowCta,
}: Props) {
  return (
    <div className="min-h-dvh w-full lg:grid lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)]">
      {desktopAside ? (
        <div className="hidden lg:block">{desktopAside}</div>
      ) : null}

      <div className="relative flex min-h-dvh flex-col bg-gradient-to-b from-brand-50 to-white">
        <main className="mx-auto flex w-full max-w-md flex-1 flex-col px-5 pt-8 pb-36 sm:max-w-lg sm:px-6 sm:pt-12 lg:max-w-lg lg:pb-16 lg:pt-16 xl:max-w-xl">
          {children}

          {desktopFlowCta ? (
            <div className="mt-10 hidden lg:block">{desktopFlowCta}</div>
          ) : null}
        </main>

        {mobileStickyCta ? (
          <div className="pointer-events-none fixed inset-x-0 bottom-0 z-10 lg:hidden">
            <div className="pointer-events-auto bg-gradient-to-t from-white via-white/95 to-white/0 px-5 pb-[max(env(safe-area-inset-bottom),16px)] pt-6 sm:px-6">
              <div className="mx-auto w-full max-w-md sm:max-w-lg">
                {mobileStickyCta}
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}
